const desktopNavSelector = '.department-nav:not(.department-nav--bar)';
const drawerSelector = '.department-drawer';
const readyAttr = 'data-department-nav-ready';

function safeId(text, index) {
  return `DepartmentNavPanel-${text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || index}`;
}

function initDesktopNav(nav) {
  if (nav.hasAttribute(readyAttr)) return;
  nav.setAttribute(readyAttr, 'true');

  const items = Array.from(nav.querySelectorAll('.department-nav__item')).filter((item) =>
    item.querySelector('.department-nav__panel')
  );
  let activeItem = null;
  let closeTimer = null;

  const setOpen = (item, open) => {
    const trigger = item.querySelector('.department-nav__trigger');
    item.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const closeAll = () => {
    window.clearTimeout(closeTimer);
    items.forEach((item) => setOpen(item, false));
    activeItem = null;
  };

  const openItem = (item) => {
    window.clearTimeout(closeTimer);
    item.querySelectorAll('template[data-department-nav-deferred]').forEach((template) => {
      template.replaceWith(template.content);
    });
    items.forEach((candidate) => setOpen(candidate, candidate === item));
    activeItem = item;
  };

  const scheduleClose = (delay = 160) => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(closeAll, delay);
  };

  items.forEach((item, index) => {
    const trigger = item.querySelector('.department-nav__trigger');
    const panel = item.querySelector('.department-nav__panel');
    if (!trigger || !panel) return;

    if (!panel.id) {
      panel.id = safeId(trigger.textContent || 'menu', index);
    }

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panel.id);
  });

  nav.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const item = event.target instanceof Element ? event.target.closest('.department-nav__item') : null;
    if (item && nav.contains(item) && item.querySelector('.department-nav__panel')) {
      openItem(item);
    }
  });

  nav.addEventListener('pointerleave', () => scheduleClose());

  nav.addEventListener('focusin', (event) => {
    const item = event.target instanceof Element ? event.target.closest('.department-nav__item') : null;
    if (item && nav.contains(item) && item.querySelector('.department-nav__panel')) {
      openItem(item);
    }
  });

  nav.addEventListener('focusout', (event) => {
    if (!event.relatedTarget || !nav.contains(event.relatedTarget)) {
      scheduleClose(80);
    }
  });

  nav.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('.department-nav__trigger') : null;
    if (!trigger || !nav.contains(trigger)) return;

    const item = trigger.closest('.department-nav__item');
    if (!item?.querySelector('.department-nav__panel')) return;
    // A click on an open department follows its link; the first tap on a touch screen opens the panel.
    if (item === activeItem) return;

    event.preventDefault();
    openItem(item);
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && nav.contains(event.target)) return;
    if (activeItem) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !activeItem) return;
    const trigger = activeItem.querySelector('.department-nav__trigger');
    closeAll();
    trigger?.focus();
  });
}

function initDrawer(drawer) {
  if (drawer.hasAttribute(readyAttr)) return;
  drawer.setAttribute(readyAttr, 'true');

  const items = Array.from(drawer.querySelectorAll('.department-drawer__item'));

  items.forEach((item) => {
    const summary = item.querySelector('.department-drawer__summary');
    summary?.setAttribute('aria-expanded', item.open ? 'true' : 'false');

    item.addEventListener('toggle', () => {
      summary?.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      if (!item.open) return;

      items.forEach((candidate) => {
        if (candidate !== item) {
          candidate.open = false;
          candidate.querySelector('.department-drawer__summary')?.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
}

function initDepartmentNav() {
  document.querySelectorAll(desktopNavSelector).forEach(initDesktopNav);
  document.querySelectorAll(drawerSelector).forEach(initDrawer);
}

initDepartmentNav();
document.addEventListener('DOMContentLoaded', initDepartmentNav);
document.addEventListener('shopify:section:load', initDepartmentNav);
